<template lang="pug">
div
  v-navigation-drawer(v-model="visibleDrawer" absolute temporary light overflow)
    v-list(dense)
      v-list-tile(@click="toChat" v-if="currentUser !== null")
        v-list-tile-content
          v-list-tile-title チャット
      v-list-tile(@click="toNewChat" v-if="viewNewChatFlg === true || viewNewMailChatFlg === true")
        v-list-tile-content
          v-list-tile-title 新しいチャットを開始
      v-divider
      //- v-list-tile(@click="toProfile" v-if="currentUser !== null")
      //-   v-list-tile-content
      //-     v-list-tile-title プロフィール編集
      //- v-list-tile(@click="toPasswordChange" v-if="currentUser !== null")
      //-   v-list-tile-content
      //-     v-list-tile-title パスワード変更
      //- v-divider
      //- v-list-tile(@click="logout" v-if="currentUser !== null")
      //-   v-list-tile-content
      //-     v-list-tile-title ログアウト
      //- v-list-tile(@click="toTop" v-if="currentUser !== null")
      //-   v-list-tile-content
      //-     v-list-tile-title トップへ戻る
  v-toolbar.white(dark fixed)
    v-toolbar-side-icon(@click.stop="visibleDrawer = !visibleDrawer"
                        v-if="enabledMenu")
    v-toolbar-title {{ title }}
    v-spacer
    img.logo(src="/user/static/logo.png")
  div.border
</template>

<script>
import Const from '@/util/const'
import BaseComponent from '@/components/BaseComponent'

const NORMAL_CHAT_PATH = '/'
const MAIL_CHAT_PATH = '/mail'

export default {
  name: 'Header',
  extends: BaseComponent,
  data () {
    return {
      visibleDrawer: false
    }
  },
  computed: {
    title () {
      return Const.title
    },
    subTitle () {
      return Const.subTitle
    },
    enabledMenu () {
      let name = this.$route.name
      return name !== 'Top' && name !== 'UserReg'
    }
  },
  methods: {
    toChat () {
      this.$router.push({ name: 'Chat' })
      this.visibleDrawer = false
    },
    toNewChat () {
      const currentPath = this.$route.path
      if (currentPath === NORMAL_CHAT_PATH) {
        this.setCurrentRoom(null)
        this.$router.push({ name: 'Chat' })
      }

      if (currentPath === MAIL_CHAT_PATH) {
        this.setCurrentMailRoom(null)
        this.$router.push({ name: 'Mail' })
      }

      this.visibleDrawer = false
    },
    toProfile () {
      this.$router.push({ name: 'Profile' })
      this.visibleDrawer = false
    },
    toPasswordChange () {
      this.$router.push({ name: 'PasswordChange' })
      this.visibleDrawer = false
    },
    toTop () {
      this.setCurrentRoom(null)
      this.setCurrentMailRoom(null)
      this.$router.push({ name: 'Top' })
    }
  }
}
</script>
<style scoped>
.material-icons.icon {
  color: #000000;
}
.toolbar__title {
  color: #000000;
}
.border {
  margin-top: 64px;
  border-bottom-style: solid;
  border-width: 0px;
  height: 10px;
  background-color: #000000;
}
.logo {
  height: 45%;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue?bb7f1b70